export default __webpack_public_path__ + "media/images/wt-facebook-9db47080.png";